import React, { useEffect } from 'react'
import {Link,navigate} from 'gatsby'
import PreviewCompatibleImage from '../PreviewCompatibleImage'
import ReactImageAppear from '../assets/plugins/react-image-appear'
const DesignViewSection = ({data,kk})=>{
    useEffect(()=>{
     
    },[])
    return(
<div 
key={kk}
id={data.node.id} 
data-sal="slide-up"
data-sal-delay="300"
data-sal-easing="ease"
className="hs_cos_wrapper hs_cos_wrapper_widget hs_cos_wrapper_type_custom_widget"
style={{display:'flex',alignItems:'flex-end'}}
>
    <div className="block_1 cu7455" onClick={()=>navigate(`${data.node.fields.slug}`)}>
      
    <Link to={data.node.fields.slug} className="company1 cu1425">
    {data.node.frontmatter.image_1 && <i className="loading-indicator"></i>}
        <div className="active_logo">
            {/* <img src={ data.node.frontmatter.featuredimage.childImageSharp.fluid.src}
            alt= {`${data.node.frontmatter.title}_color_image`}/> */}
            <ReactImageAppear src={ data.node.frontmatter.featuredimage.childImageSharp.fluid.src}
            alt= {`${data.node.frontmatter.title}_color_image`}/>
        {/* <PreviewCompatibleImage
         imageInfo={{
            childImageSharp: data.node.frontmatter.featuredimage.childImageSharp,
            alt: `${data.node.frontmatter.title}_color_image`
            }}
        /> */}
      </div>
    </Link>
    <div className="case-content en-text">
    <Link to={data.node.fields.slug} >   
    <h4> {data.node.frontmatter.title}</h4>
    <p>{data.node.frontmatter.description}</p>
    </Link>
    </div> 
</div>
</div>
    )
}
export default DesignViewSection;